module.exports = __webpack_public_path__ + "static/media/Twitter.8ebd9ca1.svg";